var lib_core = require("lib-core");
var _ = require("underscore");

var SymbolSettingsStateMachine = function (root, model) {
    ui_extensions.SettingsStateMachine.apply(this, arguments);
};

if(typeof window !== 'undefined') {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(SymbolSettingsStateMachine, ui_extensions.SettingsStateMachine);
}

module.exports = SymbolSettingsStateMachine;
